import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../hooks/useAuth';
import { useBooks } from '../../hooks/useBooks';
import WelcomeStep from './WelcomeStep';
import FirstBookStep from './FirstBookStep';

const OnboardingFlow = ({ onComplete }) => {
    const [step, setStep] = useState('welcome'); // welcome, firstBook
    const { user } = useAuth();
    const { addBook } = useBooks(user?.uid);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleWelcomeNext = () => {
        setStep('firstBook');
    };

    const handleFirstBookNext = async (bookData) => {
        setIsSubmitting(true);
        try {
            if (user) {
                // 1. 책 등록 (있을 경우)
                if (bookData) {
                    await addBook({
                        ...bookData,
                        userId: user.uid
                    });
                }

                // 2. 온보딩 완료 상태 저장
                const userRef = doc(db, 'users', user.uid);
                await setDoc(userRef, {
                    isOnboardingCompleted: true,
                    onboardingCompletedAt: new Date().toISOString()
                }, { merge: true });

                // 3. 완료 콜백
                onComplete();
            }
        } catch (error) {
            console.error('Error completing onboarding:', error);
            alert('오류가 발생했습니다. 다시 시도해주세요.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isSubmitting) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white dark:bg-ink-950">
                <div className="text-center">
                    <p className="label">SAVING</p>
                    <p className="mt-4 font-display text-xl text-ink-900 dark:text-ink-50">
                        설정을 저장하고 있어요
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white dark:bg-ink-950">
            <div className="mx-auto w-full max-w-4xl px-6">
                {step === 'welcome' && <WelcomeStep onNext={handleWelcomeNext} />}
                {step === 'firstBook' && <FirstBookStep onNext={handleFirstBookNext} />}
            </div>
        </div>
    );
};

export default OnboardingFlow;
